import React, { useState } from 'react';
import Icon from './Icon';
import { CONVERSATIONS } from '../data/conversations';

const FEATURES = [
  ['list', 'Takes the whole order', 'Sizes, spice levels, quantities and "no onions, please". It asks the follow-up questions a good host would.'],
  ['tag', 'Knows your menu and prices', 'It quotes prices on request, then reads back the order and the total before confirming.'],
  ['user', 'Recognizes the caller', '"Should I put it under the number ending in 4417?" Nobody has to spell out a phone number.'],
  ['clock', 'Gives honest pickup times', 'You set the ready-time ranges, and the AI quotes them back to every caller.'],
  ['moon', 'Knows when you’re closed', 'After hours, it shares your opening times. If you turn on pre-orders, it takes orders for when you open.'],
  ['swap', 'Hands off to a person', 'Callers can press a key to be transferred to your staff whenever they want.'],
];

export default function VoiceAI() {
  const [idx, setIdx] = useState(0);
  const [showEn, setShowEn] = useState(true);
  const convo = CONVERSATIONS[idx];

  return (
    <section className="section dark" id="voice-ai">
      <div className="wrap">
        <div className="section__head" data-reveal>
          <p className="eyebrow">Voice AI</p>
          <h2 className="h2">
            A phone host who never has a bad shift <em>and never puts anyone on hold.</em>
          </h2>
        </div>

        <div className="voice">
          <div className="voice__features">
            {FEATURES.map(([icon, title, body]) => (
              <div key={title} className="feature" data-reveal>
                <span className="icon-chip icon-chip--dark">
                  <Icon name={icon} />
                </span>
                <div>
                  <h3>{title}</h3>
                  <p>{body}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="transcript" data-reveal>
            <div className="transcript__bar">
              <div className="transcript__tabs" role="tablist" aria-label="Sample call language">
                {CONVERSATIONS.map((c, i) => (
                  <button
                    key={c.code}
                    role="tab"
                    aria-selected={i === idx}
                    className={i === idx ? 'is-active' : ''}
                    onClick={() => setIdx(i)}
                  >
                    {c.label}
                  </button>
                ))}
              </div>
              {convo.code !== 'en' && (
                <label className="switch">
                  <input type="checkbox" checked={showEn} onChange={(e) => setShowEn(e.target.checked)} />
                  <span /> English translation
                </label>
              )}
            </div>
            <ol className="transcript__lines">
              {convo.lines.map((line, i) => (
                <li key={`${convo.code}-${i}`} className={`tline tline--${line.who}`} style={{ animationDelay: `${i * 0.08}s` }}>
                  <span className="tline__who">{line.who === 'ai' ? 'AI' : 'Caller'}</span>
                  <div>
                    <p lang={convo.code}>{line.text}</p>
                    {showEn && line.en && <p className="tline__en">{line.en}</p>}
                    {line.upsell && (
                      <span className="bubble__tag">
                        <Icon name="sparkles" size={12} /> Upsell suggestion
                      </span>
                    )}
                  </div>
                </li>
              ))}
            </ol>
            <p className="transcript__note">This is a sample conversation. Your assistant uses your own menu, prices and greeting.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
